import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
import { Spacer, Container, Row, Col } from '@cleartrip/bento/lib';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "flexbox"
    }}>{`Flexbox`}</h1>
    <p>{`The flexbox utilities can be used to put together a flexbox grid.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.flex</Name>
    <Output mdxType="Output">display: flex;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-inline</Name>
    <Output mdxType="Output">display: inline-flex;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-row</Name>
    <Output mdxType="Output">flex-direction: row;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-column</Name>
    <Output mdxType="Output">flex-direction: column;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-row-reverse</Name>
    <Output mdxType="Output">flex-direction: row-reverse;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-column-reverse</Name>
    <Output mdxType="Output">flex-direction: column-reverse;</Output>
  </Property>
  
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-nowrap</Name>
    <Output mdxType="Output">flex-wrap: nowrap;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap</Name>
    <Output mdxType="Output">flex-wrap: wrap;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap-reverse</Name>
    <Output mdxType="Output">flex-wrap: wrap-reverse;</Output>
  </Property>
  
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-auto</Name>
    <Output mdxType="Output">flex: 1 1 auto;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-1</Name>
    <Output mdxType="Output">flex: 1 1 0%;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-none</Name>
    <Output mdxType="Output">flex: none;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-no-shrink</Name>
    <Output mdxType="Output">flex-shrink: 0;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-first</Name>
    <Output mdxType="Output">order: -1;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-last</Name>
    <Output mdxType="Output">order: 99;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-stretch</Name>
    <Output mdxType="Output">align-items: stretch;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-top</Name>
    <Output mdxType="Output">align-items: flex-start;</Output>
  </Property>
  <Property mdxType="Property">
  <Name mdxType="Name">.flex-middle</Name>
    <Output mdxType="Output">align-items: center;</Output>
  </Property>
  <Property mdxType="Property">
  <Name mdxType="Name">.flex-bottom</Name>
    <Output mdxType="Output">align-items: flex-end;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap-stretch</Name>
    <Output mdxType="Output">align-content: stretch;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap-top</Name>
    <Output mdxType="Output">align-content: flex-start;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap-middle</Name>
    <Output mdxType="Output">align-content: flex-center;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap-bottom</Name>
    <Output mdxType="Output">align-content: flex-end;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap-between</Name>
    <Output mdxType="Output">align-content: space-between;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.flex-wrap-around</Name>
    <Output mdxType="Output">align-content: space-around;</Output>
  </Property>
  <Property mdxType="Property">
  <Name mdxType="Name">.flex-start, .flex-left</Name>
    <Output mdxType="Output">justify-content: flex-start;</Output>
  </Property>
  <Property mdxType="Property">
  <Name mdxType="Name">.flex-end, .flex-right</Name>
    <Output mdxType="Output">justify-content: flex-end;</Output>
  </Property>
  <Property mdxType="Property">
  <Name mdxType="Name">.flex-center</Name>
    <Output mdxType="Output">justify-content: center;</Output>
  </Property>
  <Property mdxType="Property">
  <Name mdxType="Name">.flex-between</Name>
    <Output mdxType="Output">justify-content: space-between;</Output>
  </Property>
  <Property mdxType="Property">
  <Name mdxType="Name">.flex-around</Name>
    <Output mdxType="Output">justify-content: space-around;</Output>
  </Property>
    </Reference>
    <h2 {...{
      "id": "flex-direction"
    }}>{`Flex Direction`}</h2>
    <p>{`Use `}<inlineCode parentName="p">{`.flex-row`}</inlineCode>{` to position flex items horizontally from left to right.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-row bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-row">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-row-reverse`}</inlineCode>{` to position flex items horizontally in the opposite direction.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-row-reverse bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-row-reverse">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-column`}</inlineCode>{` to position flex items vertically from top to bottom.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-column bg-tertiary-100 w-100p">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-column">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-column-reverse`}</inlineCode>{` to position flex items vertically in the opposite direction.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-column-reverse bg-tertiary-100 w-100p">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-column-reverse">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "flex-wrap"
    }}>{`Flex Wrap`}</h2>
    <p>{`Use `}<inlineCode parentName="p">{`.flex-no-wrap`}</inlineCode>{` to prevent flex items from wrapping.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-nowrap bg-tertiary-100 w-100p h-52">
        <div className="w-30p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="w-40p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="w-30p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-nowrap">
        <div className="w-30p flex-none">1</div>
        <div className="w-40p flex-none">2</div>
        <div className="w-30p flex-none">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap`}</inlineCode>{` to allow flex items to wrap normally.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap bg-tertiary-100 w-100p">
        <div className="w-30p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="w-40p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="w-30p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap">
        <div className="w-30p flex-none">1</div>
        <div className="w-40p flex-none">2</div>
        <div className="w-30p flex-none">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap-reverse`}</inlineCode>{` to wrap flex items in the reverse direction.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap-reverse bg-tertiary-100 w-100p">
        <div className="w-30p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="w-40p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="w-30p flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap-reverse">
        <div className="w-30p flex-none">1</div>
        <div className="w-40p flex-none">2</div>
        <div className="w-30p flex-none">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "flex"
    }}>{`Flex`}</h2>
    <p>{`Flex is the shorthand for `}<inlineCode parentName="p">{`flex-grow`}</inlineCode>{`, `}<inlineCode parentName="p">{`flex-shrink`}</inlineCode>{` and `}<inlineCode parentName="p">{`flex-basis`}</inlineCode>{` combined. `}</p>
    <p>{`Use `}<inlineCode parentName="p">{`.flex-auto`}</inlineCode>{` to allow a flex item to grow and shrink in accordance to it's initial size.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
  <span className="c-black fs-caption-2 my-2 d-block">Default behaviour</span>
    <div className="flex bg-tertiary-100 w-100p">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Short</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Medium length</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Larger in length when compared</div>
    </div>
    <span className="c-black fs-caption-2 my-2 d-block">Flex auto</span>
    <div className="flex bg-tertiary-100 w-100p">
        <div className="flex-auto c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Short</div>
        <div className="flex-auto c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Medium length</div>
        <div className="flex-auto c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Larger in length when compared</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex">
        <div className="flex-auto">...</div>
        <div className="flex-auto">...</div>
        <div className="flex-auto">...</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-1`}</inlineCode>{` to allow a flex item to grow and shrink as needed irrespective of it's intital size.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
  <span className="c-black fs-caption-2 my-2 d-block">Default behaviour</span>
    <div className="flex bg-tertiary-100 w-100p">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Short</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Medium length</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Larger in length when compared</div>
    </div>
    <span className="c-black fs-caption-2 my-2 d-block">Flex 1</span>
    <div className="flex bg-tertiary-100 w-100p">
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Short</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Medium length</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">Larger in length when compared</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex">
        <div className="flex-1">...</div>
        <div className="flex-1">...</div>
        <div className="flex-1">...</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-none`}</inlineCode>{` to prevent a flex item from either growing or shrinking.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex bg-tertiary-100 w-100p">
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">This item can grow or shrink as needed</div>
        <div className="flex-none c-white bg-tertiary-500 px-4 py-2 m-2 ta-center">This item cannot grow or shrink</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">This item can grow or shrink as needed</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex">
        <div className="flex-1">...</div>
        <div className="flex-none">...</div>
        <div className="flex-1">...</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-no-shrink`}</inlineCode>{` to prevent a flex item from shrinking.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex bg-tertiary-100 w-100p">
        <div className="flex-none c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">This item can grow or shrink as needed</div>
        <div className="flex-no-shrink c-white bg-tertiary-500 px-4 py-2 m-2 ta-center">This item cannot shrink</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">This item can grow or shrink as needed</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex">
        <div className="flex-none">...</div>
        <div className="flex-no-shrink">...</div>
        <div className="flex-1">...</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "order"
    }}>{`Order`}</h2>
    <p>{`Use `}<inlineCode parentName="p">{`.flex-first`}</inlineCode>{` and `}<inlineCode parentName="p">{`.flex-last`}</inlineCode>{` to render flex items in a different order than their natural DOM order.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-row bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center flex-last">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center flex-first">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-row">
        <div>1</div>
        <div className="flex-last">2</div>
        <div className="flex-first">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "align-items"
    }}>{`Align Items`}</h2>
    <p>{`Used to control how flex items are position along the container's cross/vertical/(Y) axis.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`.flex-stretch`}</inlineCode>{` to stretch items to fill the container's width.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-row flex-stretch bg-tertiary-100 w-100p" style={{
          "height": "140px"
        }}>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-row flex-stretch">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-top`}</inlineCode>{` to align items to the start of the container's cross/vertical axis.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-row flex-top bg-tertiary-100 w-100p" style={{
          "height": "140px"
        }}>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-row flex-top">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-middle`}</inlineCode>{` to align items to the start of the container's cross/vertical axis.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-row flex-middle bg-tertiary-100 w-100p" style={{
          "height": "140px"
        }}>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-row flex-middle">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-bottom`}</inlineCode>{` to align items to the start of the container's cross/vertical axis.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-row flex-bottom bg-tertiary-100 w-100p" style={{
          "height": "140px"
        }}>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="flex-1 c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-row flex-bottom">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "align-content"
    }}>{`Align Content`}</h2>
    <p>{`Used to control how lines are positioned in multi-line flex containers.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap-stretch`}</inlineCode>{` for the lines to stretch and take up the remaining space.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap flex-wrap-stretch bg-tertiary-100 w-100p" style={{
          "height": "180px"
        }}>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">4</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap flex-wrap-stretch">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
        <div className="flex-1">4</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap-top`}</inlineCode>{` to pack lines at the start of cross/vertical axis in a flex container.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap flex-wrap-top bg-tertiary-100 w-100p" style={{
          "height": "180px"
        }}>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">4</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap flex-wrap-top">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
        <div className="flex-1">4</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap-middle`}</inlineCode>{` to pack lines at the center of cross/vertical axis in a flex container.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap flex-wrap-middle bg-tertiary-100 w-100p" style={{
          "height": "180px"
        }}>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">4</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap flex-wrap-middle">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
        <div className="flex-1">4</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap-bottom`}</inlineCode>{` to pack lines at the end of cross/vertical axis in a flex container.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap flex-wrap-bottom bg-tertiary-100 w-100p" style={{
          "height": "180px"
        }}>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">4</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap flex-wrap-bottom">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
        <div className="flex-1">4</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap-between`}</inlineCode>{` to distribute lines in a way that there is equal amount of space between each line.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap flex-wrap-between bg-tertiary-100 w-100p" style={{
          "height": "180px"
        }}>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">4</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap flex-wrap-between">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
        <div className="flex-1">4</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-wrap-around`}</inlineCode>{` to distribute lines in a way that there is equal amount of space around each line.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-wrap flex-wrap-around bg-tertiary-100 w-100p" style={{
          "height": "180px"
        }}>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">1</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">2</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">3</div>
        <div className="w-30p c-black bg-tertiary-400 px-4 py-2 m-2 ta-center h-24">4</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-wrap flex-wrap-around">
        <div className="flex-1">1</div>
        <div className="flex-1">2</div>
        <div className="flex-1">3</div>
        <div className="flex-1">4</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "justify-content"
    }}>{`Justify Content`}</h2>
    <p>{`Used to control how flex items are positioned along the container's main/horizontal/(X) axis.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`.flex-start`}</inlineCode>{` or `}<inlineCode parentName="p">{`.flex-left`}</inlineCode>{` to justify items against the start of the container's main/horizontal axis.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-start bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-start">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-end`}</inlineCode>{` or `}<inlineCode parentName="p">{`.flex-right`}</inlineCode>{` to justify items against the end of the container's main/horizontal axis.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-end bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-end">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-center`}</inlineCode>{` to justify items along the center of the container's main/horizontal axis.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-center bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-center">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-between`}</inlineCode>{` to justify items along the container's main/horizontal axis in a way that there is an equal amount of space between each item.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-between bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-between">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`Use `}<inlineCode parentName="p">{`.flex-around`}</inlineCode>{` to justify items along the container's main/horizontal axis in a way that there is an equal amount of space around each item.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-around bg-tertiary-100 w-100p h-52">
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">1</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">2</div>
        <div className="c-black bg-tertiary-400 px-4 py-2 m-2 ta-center">3</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="flex flex-around">
        <div>1</div>
        <div>2</div>
        <div>3</div>
    </div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      